import classNames from "classnames";
import Image from "next/image";

import { AscButton, AscHeading, AscModal } from "../";
import styles from "./AscResourceDocCard.module.scss";
import ModalIconDecor from "../../assets/illustrations/modal-icon-decor.svg";
import UnclockCircle from "../../assets/icons/unclock-circle.svg";

export interface AscResourcePurchaseModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  unlockResource: (cb: () => void) => void;
  cost: number;
}

export function AscResourcePurchaseModal({
  visible,
  setVisible,
  unlockResource,
  cost,
}: AscResourcePurchaseModalProps) {
  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={classNames(styles.resourcePurchaseModal)}
      withBackground={false}
      hasCloseBtn={false}
    >
      <div className={styles.resourcePurchase}>
        <div className={styles.iconWrapper}>
          <Image
            src={ModalIconDecor}
            alt="modal-icon-decor"
            width={160}
            height={100}
          />
          <Image
            src={UnclockCircle}
            alt="unlock-circle-icon"
            width={80}
            height={80}
          />
        </div>
        <AscHeading level={3} className={styles.resourcePurchaseTitle}>
          Unlock this resource
        </AscHeading>
        <span className={styles.resourcePurchaseSubtitle}>
          <strong>{cost.toFixed()} coins</strong> will be debited from your
          account
        </span>
        <footer className={styles.resourcePurchaseFooter}>
          <AscButton
            type="button"
            variant="secondary"
            onClick={() => setVisible(false)}
          >
            Cancel
          </AscButton>
          <AscButton
            type="button"
            onClick={() => unlockResource(() => setVisible(false))}
          >
            Confirm
          </AscButton>
        </footer>
      </div>
    </AscModal>
  );
}
